import {
  AppHeader,
  AppHeaderBackButton,
  AppHeaderLinearProgress,
  Typography,
} from '@ace-clublabs/shared-component-library';
import { Pages } from '@lib/types';
import { useHistory } from 'react-router-dom';

export interface AppHeaderProgressProps {
  description: string;
  currentStep: number;
  totalSteps: number;
  percentage: number;
  previousPage: Pages;
  styleOverrides?: object;
}
export const AppProgressHeader: (props: AppHeaderProgressProps) => JSX.Element = ({
  description,
  currentStep,
  totalSteps,
  percentage,
  previousPage,
  styleOverrides,
}) => {
  const history = useHistory();

  const handleBackButtonClickCapture = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    history.push(previousPage);
  };

  return (
    <AppHeader
      backButton={<AppHeaderBackButton onClick={handleBackButtonClickCapture} />}
      progress={<AppHeaderLinearProgress value={percentage} aria-label="progress" />}
      sx={{ padding: 0, ...styleOverrides }}
      navigation={
        <Typography variant="b3Regular" className="step-indicator" sx={{ color: '#3D4043 !important' }}>
          Step {currentStep}/{totalSteps}: {description}
        </Typography>
      }
    />
  );
};
